import { action } from 'typesafe-actions';
import { Dispatch } from 'react';
import {
  getActionTakenLabelsByProjectId,
  toActionTakenLabelConfig,
} from '../../models/api/action-taken-labels';
import { SET_ACTION_TAKEN_LABELS } from './constants';
import { ActionTakenLabelsForSubscriber } from './action-taken-labels';

export const setActionTakenLabels = (payload: ActionTakenLabelsForSubscriber) =>
  action(SET_ACTION_TAKEN_LABELS, payload);

/**
 * Load the action configuration that applies to a project, keyed by its subscriber.
 *
 * Dispatched as a side effect of loading a project, mirroring `fetchSubscriberSecurityGroups`.
 * Failures are swallowed: falling back to built-in wording and the full option set is always safe,
 * so a failed fetch must never block rendering a project.
 */
export const fetchActionTakenLabelsForProject = (projectId: string) => (
  dispatch: Dispatch<any>,
) => {
  if (!projectId) return Promise.resolve();
  return getActionTakenLabelsByProjectId(projectId)
    .then((response) =>
      dispatch(
        setActionTakenLabels({
          subscriberId: response.subscriberId,
          config: toActionTakenLabelConfig(response.labels),
        }),
      ),
    )
    .catch(() => undefined);
};
